import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminLogin, setToken } from "@/lib/adminApi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(password);
      setToken(res.token);
      toast.success("Giriş başarılı");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error("Hatalı şifre");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0E0F10] px-4">
      <Helmet><title>Yönetim Girişi</title><meta name="robots" content="noindex,nofollow" /></Helmet>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="font-display text-3xl text-[#F7F2E8]">Ankara <span className="text-[#C8A24A]">Düğün</span> Fotoğrafı</div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#9A9387] mt-1">Yönetim Paneli</div>
        </div>
        <form onSubmit={onSubmit} className="rounded-2xl bg-[#FBF7EF] p-7 border border-black/5">
          <div className="w-12 h-12 rounded-xl grid place-items-center bg-[#141517] text-[#D7B86A] mx-auto">
            <Lock className="w-6 h-6" />
          </div>
          <h1 className="font-display text-2xl text-[#141517] text-center mt-4">Giriş Yap</h1>
          <div className="grid gap-2 mt-6">
            <Label htmlFor="pw" className="text-[#141517]">Şifre</Label>
            <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="bg-white text-[#141517] border-[rgba(20,21,23,0.16)]" placeholder="Yönetici şifresi" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-button"
            className="w-full mt-5 bg-[#C8A24A] text-[#141517] hover:bg-[#D7B86A] font-semibold">
            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null} Giriş
          </Button>
        </form>
        <Link to="/" className="flex items-center justify-center gap-1.5 text-sm text-[#9A9387] mt-6 hover:text-white">
          <ArrowLeft className="w-4 h-4" /> Siteye dön
        </Link>
      </div>
    </div>
  );
}
